import { render } from "./ElementErrors.vue?vue&type=template&id=5d98d362"
import script from "./ElementErrors.vue?vue&type=script&lang=js"
export * from "./ElementErrors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__